// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"245fc556","42":"8c4afe9d","44":"9952e8e8","173":"8fadc435","392":"d2677196","470":"0f689f18","520":"e778644b","561":"bac2e8ef","677":"d9abcf90","814":"f33d2858","815":"418f16a4","915":"337e5072"}[chunkId] + ".chunk.js";
};